import { notification } from "antd";
import { BaseUrl, JsonConfig } from "../../Repository/BaseRepository";
import axios from "axios";
import { GetDefaultDate } from "../../Utils/Utils";

const NotificationAlert = async () => {

    const URL = BaseUrl + "Home/autocrawlstatus";
    const Response = await axios.get(URL, JsonConfig);
    if (Response != null) {

        let BatchLabel = JSON.parse(Response.data).BatchLabel;
        let DateLabel = BatchLabel.split(" ")[1];
        let CurrentDate = GetDefaultDate();
        if (DateLabel == CurrentDate) {
            return (
                notification.success({
                    message: 'AutoCrawl Completed',
                    description: JSON.parse(Response.data).BatchLabel,
                    duration: 4,
                    maxCount: 1,
                    placement:"top",
                    style:{backgroundColor:"#e8f5fc"}
                })
            )
        }
    }

}

const ValidateAutoCrawlStatus = async () => {
    if (window.location.pathname == "/dashboard" || window.location.pathname == "/admin-dashboard") {
        await NotificationAlert();
    }
    return null;
}

export default ValidateAutoCrawlStatus;